import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initializeCSRF } from './services/api';
import { initializeMonitoring, setupGlobalErrorHandler } from './services/monitoring';

// Initialize monitoring and error tracking
initializeMonitoring();
setupGlobalErrorHandler();

// Initialize CSRF token protection on app load
initializeCSRF();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
